/* ======================================================================== */
/* 31. fontObserver */
/* ======================================================================== */
function fontObserver() {

	return new Promise(function (resolve, reject) {

		var observers = [];

		// bypass if there are no fonts came from backend
		// or if the WP Customizer preview is active
		// or in Elementor Editor
		if (!window.theme.fonts || (typeof wp !== 'undefined' && typeof wp.customize !== 'undefined') || window.theme.isElementorEditorActive) {
			resolve(true);
			return;
		}

		$.each(window.theme.fonts, function () {
			var currentObserver = new FontFaceObserver(this);

			observers.push(currentObserver.load());
		});

		Promise
			.all(observers)
			.then((e) => {
				resolve(true);
			})
			.catch(() => {
				const
					errorHeading = 'Fonts Loading Failed',
					errorMessage = 'Font Observer: There is a critical error occured while loading one or more theme fonts.',
					errorDescription = 'This message won\'t appear to the website visitors.';

				console.error(errorMessage);
				console.log(observers);
				if ( typeof elementorCommon !== 'undefined' ) {
					elementorCommon.dialogsManager.createWidget('confirm', {
						id: 'elementor-fatal-error-dialog',
						headerMessage: errorHeading,
						message: `${errorMessage}<br><br>${errorDescription}`,
						strings: {
							confirm: 'How to fix?',
							cancel: 'Close'
						},
						onConfirm: () => {
							return window.open('https://docs.artemsemkin.com/cassio/wp/tips-tricks/troubleshooting-fonts-loading-issues.html', '_blank');
						},
					}).show();
				}
				reject(true);
			});

	});

}
